/**
 * @copyright Elmelo Ltd.
 */
import React from 'react'
import {
    Container,
    Button,
    Image,
    Form,
} from 'react-bootstrap'
import {connect} from 'react-redux'
import * as actions from '../../rdx/actions'

// import NavHdr from '../_common/nav_hdr'
// import color from '../_common/colors.json'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
    faPlusSquare,
    faTrashAlt,
    faCheck,
    faCircle,
    faAlignJustify,
    faTimes,
    faTruckMoving,
    faShoppingBag,
    faMoneyBill,
    faArrowDown,
    faCreditCard,
    faPlus,
    faMinus,
    faTicketAlt, faCheckCircle
} from '@fortawesome/free-solid-svg-icons'
import './css/checkout.css'

// import {
//     Checkout_Personal, Checkout_Payment,Checkout_Summary, Checkout_Delivery
// }from './index'
import Checkout_Personal from './personal'
import Checkout_Delivery from './delivery'
import Checkout_Payment from './payment'
import Checkout_Summary from './summary'
// import Checkout_Success from './success'

import { navigate } from "@reach/router"

/**
 */
class Checkout_Home extends React.PureComponent
{
    /**
     */
    constructor( props )
    {
        super( props )
        this.state={
            customer:true,
            delivery:false,
            payment:false,
            customerCom:false,
            deliveryCom:false,
            paymentCom:false,
        }
    }

    /**
     */
    componentDidMount()
    {

    }

    showCustomer =(val) =>
    {
        this.setState({customer:val,payment:true ,customerCom: true })
    }

    showDelivery =(val, h_p) =>
    {
        this.setState({delivery:val, payment: this.state.paymentCom ? false : h_p ? false : true , deliveryCom: h_p ? false : true})
    }

    showPayment =(val,h_d) =>
    {
        this.setState({payment:val , paymentCom: h_d ? false : true })

        if(h_d)
            this.setState({delivery:false})

    }
    onClose = () => {
        // this.props.Rdx_Checkout_Clear();
        // navigate('order')
        if( this.props.location.state.fromPage )
        {
            navigate(this.props.location.state.fromPage);
        }
        else
        {
            navigate('/order')
        }
    }

    /**
     */
    render()
    {
        // // console.log("states of customer",this.state);
        // // console.log("props of checkout",this.props);

        if(!this.props.__biz.biz_id)
        {
            if( this.props.location.state.fromPage )
            {
                navigate(this.props.location.state.fromPage);
            }
            else
            {
                navigate('/order')
            }
        }

        return (
            <div style={{paddingTop: 0}}>
                <div className="overlay">
                    <div className="orderProcessHeader">
                        <h3 style={{flex:1}}>Checkout Order</h3>
                        <Button onClick={()=> this.onClose() } variant="light">
                            <FontAwesomeIcon
                                style={{width:50}}
                                icon={faTimes} size="lg" color="#ef5350"/>
                        </Button>
                    </div>
                    <div>
                        <div>
                            {
                                this.state.customerCom ?
                                    <div style={{marginTop: 64}} className="processTabComp">
                                        <FontAwesomeIcon style={{marginTop: 5}} icon={faShoppingBag} size="lg"
                                                         color="green"/>
                                        <div className="processSelect">Customer Details</div>
                                        <FontAwesomeIcon style={{marginTop: 5, marginLeft: "auto"}} icon={faCheckCircle}
                                                         size="lg" color="green"/>
                                    </div> :
                                    null
                            }
                            {
                                this.state.paymentCom ?
                                    <div className="processTabComp">
                                        <FontAwesomeIcon style={{marginTop: 5}} icon={faMoneyBill} size="lg"
                                                         color="green"/>
                                        <div className="processSelect">Payment Details</div>
                                        <FontAwesomeIcon style={{marginTop: 5, marginLeft: "auto"}} icon={faCheckCircle}
                                                         size="lg" color="green"/>
                                    </div> :
                                    null
                            }

                            {/*<div className="processBox">*/}
                            {/*    {!this.state.customerCom ?*/}
                            {/*        <div className="processTabSelect">*/}
                            {/*            <FontAwesomeIcon icon={faShoppingBag} size="lg" color="#155799"/>*/}
                            {/*            <div className="processText" style={{color:"#155799"}}>Customer Details</div>*/}
                            {/*        </div> :*/}
                            {/*        <div className="processTab">*/}
                            {/*            <FontAwesomeIcon icon={faCheck} size="lg" color="green"/>*/}
                            {/*            <div className="processText">Customer Details</div>*/}
                            {/*        </div>*/}
                            {/*    }*/}
                            {/*    {!this.state.deliveryCom  ?*/}
                            {/*        <div className="processTabSelect">*/}
                            {/*            <FontAwesomeIcon icon={faTruckMoving} size="lg" color="#155799"/>*/}
                            {/*            <div className="processText" style={{color:"#155799"}}>Delivery Details</div>*/}
                            {/*        </div> :*/}
                            {/*        <div className="processTab">*/}
                            {/*            <FontAwesomeIcon icon={faCheck} size="lg" color="green"/>*/}
                            {/*            <div className="processText">Delivery Details</div>*/}
                            {/*        </div>*/}
                            {/*    }*/}
                            {/*    {*/}
                            {/*        !this.state.paymentCom ?*/}
                            {/*            <div className="processTabSelect">*/}
                            {/*                <FontAwesomeIcon icon={faMoneyBill} size="lg" color="#155799"/>*/}
                            {/*                <div className="processText" style={{color: "#155799"}}>Payment Details*/}
                            {/*                </div>*/}
                            {/*            </div> :*/}
                            {/*            <div className="processTab">*/}
                            {/*                <FontAwesomeIcon icon={faCheck} size="lg" color="green"/>*/}
                            {/*                <div className="processText">Payment Details</div>*/}
                            {/*            </div>*/}
                            {/*    }*/}
                            {/*</div>*/}


                            {
                                this.state.customer ?
                                    <div>
                                        <Checkout_Personal showCustomer={this.showCustomer}/>

                                    </div>
                                    : null
                            }

                            {   this.state.payment ?
                                    <div>
                                        <Checkout_Payment showPayment={this.showPayment}/>
                                    </div>:null
                            }
                            {/*{*/}
                            {/*    this.state.delivery ?*/}
                            {/*        <div>*/}
                            {/*            <Checkout_Delivery showDelivery={this.showDelivery}/>*/}
                            {/*        </div>:*/}
                            {/*        null*/}
                            {/*}*/}
                        </div>
                        <Checkout_Summary
                            showDelivery={this.showDelivery}
                            showPayment={this.showPayment}
                            confirmPayment={this.state.customerCom && this.state.paymentCom ? true : false}
                            // confirmPayment={this.state.customerCom && this.state.deliveryCom && this.state.paymentCom ? true : false}
                        />
                    </div>
                </div>
            </div>
        )
    }


}   // class Info_Home
/**
 */
const mapStateToProps = (state) =>
{
    return state
}   //

/**
 */
export default connect(mapStateToProps, actions)( Checkout_Home )


